import { handleActions } from "redux-actions";
import actionCreators from "../../actions/service/index_of_signed_in";

const initialState = {
  isWebViewTabApp: false,
  circles: [],
  newArrivalCircles: [],
  events: [],
  blogs: [],
  reports: [],
  currentUser: {},
  serviceName: "",
};

export default handleActions(
  {
    [actionCreators.service.indexOfSignedIn.set]: (state, action) =>
      Object.assign({}, state, action.payload),
  },
  initialState
);
